var _path, _rect, _rect2, _rect3, _line, _line2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssuesEmptyStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 158,
    viewBox: "0 0 449 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.537 0H190.736V9.87274H209.901V127.184H236.616V22.6492H288.883V60.3979H295.852V46.4599H309.79V60.3979H324.309V46.4599L361.477 58.8402V96.4044H381.222V127.184H402.71V134.153H381.222H361.477H352.766H336.505H324.309H309.79H295.852H288.883H274.945H236.616H209.901H190.736H165.183H160.537H151.826H123.37H121.047H111.174H105.366H77.4903H67.0369H46.1299V127.184H67.0369V112.085H77.4903V91.7584H105.366V112.085H111.174V73.7552V58.6557C111.174 51.9202 116.634 46.4599 123.37 46.4599C130.105 46.4599 135.565 51.9202 135.565 58.6557V73.7552H151.826V9.87274H160.537V0Z",
    fill: "#F4F7F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 94.5,
    width: 89,
    height: 58,
    rx: 3.8,
    fill: "white",
    stroke: "#B7BCC2",
    strokeWidth: 3.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 81,
    width: 89,
    height: 58,
    rx: 3.8,
    fill: "white",
    stroke: "#6F7985",
    strokeWidth: 3.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 65.5,
    width: 96,
    height: 58,
    rx: 3.8,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 237,
    y1: 89.6,
    x2: 270.715,
    y2: 89.6,
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 237,
    y1: 100.839,
    x2: 259.476,
    y2: 100.839,
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.736 81.8708C210.647 80.2937 212.923 80.2937 213.833 81.8708L227.737 105.952C228.647 107.529 227.509 109.5 225.688 109.5H197.882C196.061 109.5 194.923 107.529 195.833 105.952L209.736 81.8708Z",
    fill: "#FFC700",
    stroke: "#212A35",
    strokeWidth: 2.36557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212 97.7601V89.9907M212 103.519V103.587",
    stroke: "#212A35",
    strokeWidth: 2.36557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuesEmptyStateIcon);
export default __webpack_public_path__ + "static/media/issuesEmptyStateIcon.a269d1e05085c4ade1e708b5fb57a01c.svg";
export { ForwardRef as ReactComponent };